import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'
import AuthApi from '../../api/auth/AuthApi'
import { HttpError } from '../../types/common'
import { showErrorToast } from '../../utils/errors'
import { VerifyEmailDto } from '../../api/auth/types'

const authApi = AuthApi.getInstance()

export function useCheckPwdResetCode() {
  const texts = useTranslation().t

  const mutation = useMutation(async (body: VerifyEmailDto) => {
    const { data } = await authApi.checkPwdResetCode(body)
    return data
  }, {
    onError: (error: AxiosError<HttpError>) => {
      showErrorToast(error, texts)
    }
  })
  return mutation
}